const URL_PAGE = {
  PERSONAL_DETAILS: 'personal-details',
  SHIPPING: 'shipping',
  BILLING: 'billing'
};

export const getCurrentStep = (pathname: string) => {
  const normalizedPathname = pathname.replace(/\/$/, '');

  if (normalizedPathname.includes(URL_PAGE.PERSONAL_DETAILS)) {
    return 1;
  }
  if (normalizedPathname.includes(URL_PAGE.SHIPPING)) {
    return 2;
  }
  if (normalizedPathname.includes(URL_PAGE.BILLING)) {
    return 3;
  }
  return 1;
};

export { default as Header } from './Header';
